/* global apiURL */ 
import './../scss/main.scss'
import './../../node_modules/tiny-slider/src/tiny-slider.scss'
import { initMap } from './htm_map-list.js'
import { tns } from './../../node_modules/tiny-slider/src/tiny-slider'

window.addEventListener("DOMContentLoaded", init)

function init() {
  console.log('running init!')
  // Add arrows on buttons with class .arrow-right
  const arrowButtonsRight = document.querySelectorAll('.eut-btn.arrow-right span')
  for (let i = 0; i < arrowButtonsRight.length; i++) {
    const element = arrowButtonsRight[i];
    element.insertAdjacentHTML('afterend', '<svg aria-hidden="true" focusable="false" data-prefix="fal" data-icon="chevron-right" class="svg-inline--fa fa-chevron-right fa-w-8" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 256 512"><path fill="currentColor" d="M17.525 36.465l-7.071 7.07c-4.686 4.686-4.686 12.284 0 16.971L205.947 256 10.454 451.494c-4.686 4.686-4.686 12.284 0 16.971l7.071 7.07c4.686 4.686 12.284 4.686 16.97 0l211.051-211.05c4.686-4.686 4.686-12.284 0-16.971L34.495 36.465c-4.686-4.687-12.284-4.687-16.97 0z"></path></svg>')
  }
  // Add arrows on buttons with class .arrow-left
  const arrowButtonsLeft = document.querySelectorAll('.eut-btn.arrow-left span')
  for (let i = 0; i < arrowButtonsLeft.length; i++) {
    const element = arrowButtonsLeft[i];
    element.insertAdjacentHTML('beforebegin', '<svg aria-hidden="true" focusable="false" data-prefix="fal" data-icon="chevron-left" class="svg-inline--fa fa-chevron-left fa-w-8" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 256 512"><path fill="currentColor" d="M238.475 475.535l7.071-7.07c4.686-4.686 4.686-12.284 0-16.971L50.053 256 245.546 60.506c4.686-4.686 4.686-12.284 0-16.971l-7.071-7.07c-4.686-4.686-12.284-4.686-16.97 0L10.454 247.515c-4.686 4.686-4.686 12.284 0 16.971l211.051 211.05c4.686 4.686 12.284 4.686 16.97-.001z"></path></svg>')
  }

  //Init partner-loop
  console.log(document.querySelector('.htm_partner-loop'))
  if(document.querySelector('.htm_partner-loop')) {
    const slider = tns({
      container: '.htm_partner-loop__inner',
      items: 5,
      autoplay: true,
      controls: false,
      nav: false,
      autoplayButtonOutput: false,
      gutter: 30,
      autoplayTimeout: 2000,
      responsive: {
        1: {
          items: 2
        },
        500: {
          items: 5
        }
      }
    })
  }

  initMap(apiURL);

  function getCookie(cname) {
    let name = cname + "=";
    let decodedCookie = decodeURIComponent(document.cookie);
    let ca = decodedCookie.split(';');
    for(let i = 0; i <ca.length; i++) {
      let c = ca[i];
      while (c.charAt(0) == ' ') {
        c = c.substring(1);
      }
      if (c.indexOf(name) == 0) {
        return c.substring(name.length, c.length);
      }
    }
    return false;
  }

  const newsletterOverlay = document.querySelector('.newsletter-overlay')
  const newsletterClose = document.querySelector('.newsletter-close')
  const newsletterSubmit = document.getElementById('mc-embedded-subscribe')
  const initialScrollY = document.documentElement.scrollTop || document.body.scrollTop
  console.log('initialScrollY', initialScrollY);
  // console.log('scrollTop', document.body.scrollTop);

  document.addEventListener('scroll', (e) => {
    if (!newsletterOverlay.classList.contains('show') && !getCookie('showNewsletterPopUp')) {
      if (initialScrollY > 100) {
        console.log('1 scrollY', window.scrollY);
        if (window.scrollY >= initialScrollY - 100) {
          console.log('1 you have scrolled more than 100px')
          newsletterOverlay.classList.add('show')
        }
      } else {
        console.log('2 scrollY', window.scrollY);
        if (window.scrollY - 100 >= initialScrollY) {
          console.log('2 you have scrolled more than 100px')
          newsletterOverlay.classList.add('show')
        }
      }
    }
  })

  newsletterOverlay.addEventListener('click', (e) => {
    console.log('target', e.target);
    console.log('currentTarget', e.currentTarget);
    if (e.target === e.currentTarget) {
      newsletterOverlay.classList.remove('show')
      document.cookie = `showNewsletterPopUp=false; max-age=${60 * 60 * 24 * 14}; path=/;`;
    }
  })

  newsletterSubmit.addEventListener('click', (e) => {
    document.cookie = `showNewsletterPopUp=false; max-age=${60 * 60 * 24 * 14}; path=/;`;
  })

  newsletterClose.addEventListener('click', (e) => {
    newsletterOverlay.classList.remove('show')
    document.cookie = `showNewsletterPopUp=false; max-age=${60 * 60 * 24 * 14}; path=/;`;
  })
}



{/* <script>
  var slider = tns({
    container: '.my-slider',
    items: 1,
    responsive: {
      640: {
        edgePadding: 20,
        gutter: 20,
        items: 2
      },
      700: {
        gutter: 30
      },
      900: {
        items: 3
      }
    }
  });
</script> */}